import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  withCredentials: true 
});

// Flag για να μην κάνει πολλαπλά refresh ταυτόχρονα
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Request interceptor: Βάζει το Token σε κάθε αίτημα
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: Πιάνει τα 401 και κάνει Refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Αν φάμε 401 και ΔΕΝ είμαστε ήδη στη διαδικασία του refresh...
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      
      // Αν το αίτημα που απέτυχε ΗΤΑΝ το ίδιο το refresh, σημαίνει ότι έληξαν όλα!
      // Κάνουμε logout τον χρήστη για να σταματήσει η λούπα.
      if (originalRequest.url.includes('/api/auth/refresh')) {
          console.warn('Refresh token failed. Redirecting to login.');
          localStorage.removeItem('token');
          window.location.href = '/login';
          return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise(function(resolve, reject) {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return api(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const { data } = await api.post('/api/auth/refresh');
        
        // Αποθηκεύουμε το νέο token
        localStorage.setItem('token', data.token);
        
        api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        originalRequest.headers['Authorization'] = `Bearer ${data.token}`;
        
        processQueue(null, data.token);
        
        return api(originalRequest);
      } catch (err) {
        // ΑΝ ΑΠΟΤΥΧΕΙ ΤΟ REFRESH: Διώχνουμε τον χρήστη στο Login
        processQueue(err, null);
        localStorage.removeItem('token');
        window.location.href = '/login';
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;